import { Component, Input } from "@angular/core";
import { CaretIconType } from "./caret-icon";

@Component({
    standalone: true,
    selector: 'gene-caret-icon',
    templateUrl: './caret-icon.component.html',
    styleUrls: ['./caret-icon.component.css']
})
export class CaretIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;

    @Input() type!: CaretIconType;

    @Input() isOpen?: boolean = false;
};